import { Component, useEffect } from "react";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import RefreshButton from "../../../shared/ui/Refresh.Button";
import WithdrawTableButtons from "./Table/WithdrawTableButtons";

import {
  withdrawalReasonOptions,
  willInvestorBeBackOptions,
} from "admin/shared/dictionary/enums";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import { allClaimsOtherThanAml } from "../../../shared/ClaimLists/Claim.Aml.All.List";
import PropTypes from "prop-types";

class TableCellWithdrawalActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      date: new Date(props.item.OrderDate),
      amount: props.item.Amount.Amount,
    };
  }

  handleOpen = () => {
    this.setState({
      open: true,
      date: new Date(this.props.item.OrderDate),
      amount: this.props.item.Amount.Amount,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
      date: this.state.date,
      amount: this.state.amount,
    });
  };

  handleConfirm = () => {
    this.props.approveWithdrawalOrder(
      this.props.item.Id,
      this.props.item.AccountId,
      this.props.item.DepotId,
      this.state.amount,
      this.state.date,
    );
    this.handleClose();
  };

  handleChangeDate = (event, date) => {
    this.setState({
      date: date,
      open: this.state.open,
      amount: this.state.amount,
    });
  };

  handleCancel = () => {
    this.props.cancelWithdrawalOrder(this.props.item.Id);
    this.handleClose();
  };

  handleChangeAmount = (event, amount) => {
    this.setState({
      date: this.state.date,
      open: this.state.open,
      amount: amount,
    });
  };

  render() {
    const actions = [
      <Button
        variant="outlined"
        key="1"
        color="primary"
        onClick={this.handleConfirm}
      >
        Confirm
      </Button>,
      <Button variant="outlined" key="2" onClick={this.handleCancel}>
        Reject
      </Button>,
      <Button variant="outlined" key="3" onClick={this.handleClose}>
        Close
      </Button>,
    ];
    return (
      <div className="table-cell-actions">
        <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
          <Button
            style={
              this.props.item.AmlWarning ? { backgroundColor: "#dec1c3" } : {}
            }
            variant="contained"
            color="primary"
            onClick={this.handleOpen}
          >
            Confirm/Reject
          </Button>
          {this.props.item.AmlWarning && (
            <div style={{ color: "red", textAlign: "center" }}>
              AML warning!
            </div>
          )}
          {this.props.item.AmlWarning === null && (
            <div style={{ color: "#ef8a00", textAlign: "center" }}>
              AML pending
            </div>
          )}
        </ClaimsWrapper>
        <Dialog modal={false} open={this.state.open}>
          <DialogTitle>Approve withdrawal order</DialogTitle>
          <DialogContent>
            Withdrawal Order Id <br />
            {this.props.item.Id}
            <br />
            Amount <br />
            <TextField
              size="small"
              variant="outlined"
              value={this.state.amount}
              onChange={this.handleChangeAmount}
              label="Amount"
            />
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}

TableCellWithdrawalActions.propTypes = {
  item: PropTypes.object,
  approveWithdrawalOrder: PropTypes.func,
  cancelWithdrawalOrder: PropTypes.func,
};

const WithdrawalsComponent = ({
  accountId,
  currentUser,
  withdraw,
  approveWithdrawalOrder,
  cancelWithdrawalOrder,
  fetchWithdrawalOrdersByAccount,
  fetchWithdrawalOrders,
  approveWithdrawalOrders,
  ...props
}) => {
  const createColumns = () => [
    {
      key: "AccountId",
      label: "Account Id",
      visible: true,
      type: CELL_TYPES.text,
      renderer: (value) => {
        return <TableCellAccountRedirect value={value} type={"accountId"} />;
      },
    },
    { key: "IntId", label: "Int Id", visible: true, type: CELL_TYPES.number },
    {
      key: "Amount.Amount",
      label: "Amount",
      visible: true,
      type: CELL_TYPES.money,
    },
    {
      key: "OriginatorDepotMainAccountBalance",
      label: "Originator Depot Main Account Balance",
      visible: true,
      type: CELL_TYPES.money,
      renderer: (value) => {
        return <div>{value ? value : "-"}</div>;
      },
    },
    {
      key: "Currency",
      label: "Currency",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "BankAccountCurrency",
      label: "Bank Account Currency",
      visible: true,
      type: CELL_TYPES.text,
    },
    { key: "DepotId", label: "Depot Id", visible: true },
    { key: "HighRiskFlag", label: "High risk flag", visible: true },
    { key: "BankAccountNumber", label: "Bank account", visible: true },
    { key: "BankName", label: "Bank", visible: true },
    {
      key: "OrderDate",
      label: "Order date",
      visible: true,
      type: CELL_TYPES.date,
    },
    { key: "RefCode", label: "Ref Code", visible: true },
    {
      key: "Reason",
      label: "Withdrawal Reason",
      visible: true,
      enumDict: withdrawalReasonOptions,
      type: CELL_TYPES.enum,
    },
    {
      key: "WillInvestorBeBack",
      label: "Will Investor be back",
      visible: true,
      enumDict: willInvestorBeBackOptions,
      type: CELL_TYPES.enum,
    },
    {
      key: "ImprovementSuggestion",
      label: "Improvement Suggestion",
      visible: true,
    },
    {
      key: "actions",
      label: "Actions",
      visible: true,
      renderer: (value, item) => {
        return (
          <TableCellWithdrawalActions
            approveWithdrawalOrder={approveWithdrawalOrder}
            cancelWithdrawalOrder={cancelWithdrawalOrder}
            item={item}
            value={value}
          />
        );
      },
    },
  ];

  useEffect(() => {
    if (accountId) {
      fetchWithdrawalOrdersByAccount(accountId);
    } else if (withdraw.data && !withdraw.data.length) {
      fetchWithdrawalOrders();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser?.Ssn]);

  let ordersByCurrency = {};
  if (withdraw.fetched) {
    for (let order of withdraw.data) {
      if (!ordersByCurrency[order.Currency]) {
        ordersByCurrency[order.Currency] = [];
      }
      ordersByCurrency[order.Currency].push({
        ...order,
        bgColor: order.OriginatorDepotMainAccountBalance < 0 ? "#ee7070" : null,
      });
    }
  }

  //Make sure SEK, EUR come in predictable order but we still show unexpected currencies also so uses notice.
  let currencies = [
    "SEK",
    "EUR",
    ...Object.keys(ordersByCurrency).filter((x) => x !== "SEK" && x !== "EUR"),
  ];

  let tables = withdraw.fetched
    ? currencies.map((currency) => (
        <div key={currency}>
          <h4>{currency}</h4>
          <TableNew
            {...props}
            selectId={"Id"}
            columns={createColumns()}
            items={ordersByCurrency[currency]}
            actionColumnWidth={200}
            order="-OrderDate"
            tableKey="withdrawal_orders"
            aboveContentRenderer={(getSelected, rows, props) => {
              return (
                <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
                  <WithdrawTableButtons
                    {...props}
                    currency={currency}
                    approveWithdrawalOrders={approveWithdrawalOrders}
                    getSelected={getSelected}
                    rows={rows}
                  />
                </ClaimsWrapper>
              );
            }}
          />
        </div>
      ))
    : null;

  let refreshFunction = accountId
    ? fetchWithdrawalOrdersByAccount.bind(this, accountId)
    : fetchWithdrawalOrders;
  return (
    <div className="deposit-layout body-height">
      <RefreshButton onRefreshClick={refreshFunction} />
      <h3>Pending withdrawal orders</h3>
      {withdraw.fetched ? tables : <div>Fetching data...</div>}
    </div>
  );
};

WithdrawalsComponent.propTypes = {
  accountId: PropTypes.string,
  currentUser: PropTypes.object,
  withdraw: PropTypes.object,
  approveWithdrawalOrder: PropTypes.func,
  cancelWithdrawalOrder: PropTypes.func,
  fetchWithdrawalOrdersByAccount: PropTypes.func,
  fetchWithdrawalOrders: PropTypes.func,
  approveWithdrawalOrders: PropTypes.func,
};

export default WithdrawalsComponent;
